/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-unused-expressions */
import React, { memo, useEffect, useMemo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Input, Label, Row, Button } from 'reactstrap';
import { updateEpikBox, updateSipPri } from '../../../../../actions/EpikBoxes';
import {
  SELECTED_OPTIONS,
  SIP_IP_ADDRESS,
  SIP_IP_ADDRESS_WITHOUT_ONE,
  SIP_PORT,
} from './constants';

export const EpikboxSip = memo(({ sipDetails, priSipStatus, setDcUpdatePopup }) => {
  const box = useSelector(state => state.AppState.boxDetails.box);
  const sipSettings = useSelector(state => state.AppState.priSipData?.sipSettingData);
  const [username, setUsername] = useState(sipSettings?.username || '');
  const [password, setPassword] = useState(sipSettings?.password || '');
  const [ipAddress, setIpAddress] = useState(sipSettings?.ip || '');
  const [selectedOptions, setSelectedOption] = useState(sipSettings?.authType || '');
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;

  const isAuthenticationIpAuth = useMemo(() => !!(selectedOptions === SELECTED_OPTIONS.IP_AUTH), [
    selectedOptions,
  ]);

  const onSubmit = async () => {
    if (!ipAddress) return;
    const ispri = false;

    let ip = ipAddress;
    switch (selectedOptions) {
      case SELECTED_OPTIONS.USERNAME_PASSWORD:
        ip = SIP_IP_ADDRESS;
        break;
      case SELECTED_OPTIONS.IP_AUTH:
        ip = SIP_IP_ADDRESS_WITHOUT_ONE.concat(ipAddress);
        break;
      default:
        break;
    }

    const body = { username, password, ipAddress: ip };

    const sipNumberSettings = {
      username: isAuthenticationIpAuth ? '' : username,
      password: isAuthenticationIpAuth ? '' : password,
      ip,
      authType: selectedOptions.toLowerCase(),
      numberSettings: sipSettings?.numberSettings,
    };
    const updatedFeature = { ...box?.features, pri: priSipStatus?.pri, sip: priSipStatus?.sip };

    await dispatch(updateSipPri(token, box?._id, ispri, sipNumberSettings)); // updating SipPri based on current authtype

    sipDetails(token, body); // discuss it with haseem later since it is doing nothing

    await dispatch(
      updateEpikBox(token, {
        ...box,
        features: updatedFeature,
        sipSettings: sipNumberSettings,
      }),
    );
  };

  useEffect(() => {
    setUsername(sipSettings?.username || '');
    setPassword(sipSettings?.password || '');
    setIpAddress(sipSettings?.ip || '');
    setSelectedOption(sipSettings?.authType || '');
  }, [sipSettings]);

  useEffect(() => {
    if (isAuthenticationIpAuth && sipSettings?.ip)
      setIpAddress(
        sipSettings?.ip.substring(sipSettings?.ip.lastIndexOf('.') + 1, sipSettings?.ip.length),
      );
  }, [selectedOptions, sipSettings]);

  const handleSelectedOption = useCallback(e => {
    const { value } = e.currentTarget;
    setSelectedOption(e.currentTarget.value);
    value === SELECTED_OPTIONS.USERNAME_PASSWORD ? setIpAddress(SIP_IP_ADDRESS) : setIpAddress('');
  }, []);

  const handleInputChnage = useCallback(e => {
    const { value } = e.target;
    if (value.length > 3) return;
    setIpAddress(value);
  }, []);

  const IpInfo = () => (
    <>
      <Row className="sip-input ">
        <Col sm={6} md={4}>
          <Label className="sip-input-label">IP Info</Label>
        </Col>
        <Col sm={6} md={5} className="center">
          <div className="center-vertically">
            <span>{SIP_IP_ADDRESS}</span>
            <span>{`Port: ${SIP_PORT}`}</span>
          </div>
        </Col>
      </Row>
    </>
  );

  return (
    <div className="priContainer">
      <p className="heading">SIP Settings</p>
      <div className="sip-section ">
        <Row className="sip-input ">
          <Col sm={6} md={4}>
            <Label for="name" className="sip-input-label">
              Authentication
            </Label>
          </Col>
          <Col sm={6} md={5}>
            <Input type="select" value={selectedOptions} onChange={handleSelectedOption}>
              {!selectedOptions && (
                <option key="selectType" value="">
                  Select Type
                </option>
              )}
              <option key="ipAuth" value="ipauth">
                IP Auth
              </option>
              <option key="username/password" value="username/password">
                Username/Password
              </option>
            </Input>
          </Col>
        </Row>
      </div>
      {!isAuthenticationIpAuth && selectedOptions === SELECTED_OPTIONS.USERNAME_PASSWORD && (
        <div className="sip-section ">
          <Row className="sip-input ">
            <Col sm={6} md={4}>
              <Label for="name" className="sip-input-label">
                Username:
              </Label>
            </Col>
            <Col sm={6} md={5}>
              <Input
                onChange={e => setUsername(e.target.value)}
                placeholder="Enter Username"
                required
                value={username}
                type="text"
                name="username"
              />
            </Col>
          </Row>
          <Row className="sip-input ">
            <Col sm={6} md={4}>
              <Label for="name" className="sip-input-label">
                Password:
              </Label>
            </Col>
            <Col sm={6} md={5}>
              <Input
                style={{ with: '100%' }}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password"
                required
                value={password}
                type="password"
                name="password"
              />
            </Col>
          </Row>
          {IpInfo()}
        </div>
      )}
      {isAuthenticationIpAuth && (
        <div className="sip-section ">
          <Row className="sip-input ">
            <Col sm={6} md={4}>
              <Label for="name" className="sip-input-label">
                IP Address:
              </Label>
            </Col>
            <div className="port-container__ip-auth">
              <Label className="sip-input-label big-font">{SIP_IP_ADDRESS_WITHOUT_ONE}</Label>
              <div className="one-digit-input">
                <Input
                  onChange={handleInputChnage}
                  required
                  value={ipAddress}
                  type="number"
                  name="ipAddress"
                  min="0"
                  max="1000"
                  step="3"
                />
              </div>
            </div>
          </Row>
        </div>
      )}
      <Row>
        <Col className="pri-save-btn">
          <Button color="primary" 
          onClick={ () => {
            const divElement = document.getElementById('test-time-remaining');
            const isHidden = divElement.getAttribute('hidden') !== null;
            if (isHidden) {
              setDcUpdatePopup({ show: true });
            } else {
              onSubmit();
            }
          }}>
            Save SIP Detail
          </Button>
        </Col>
      </Row>
    </div>
  );
});

export default EpikboxSip;
